// extracted by mini-css-extract-plugin
module.exports = {"option":"style_option__E7LtZ"};